// these are just placeholders for the child component to populate
import {IOrganization} from "../../index";
import {Organization} from "./system-permission/Organization";

interface ICreatePermissionsParams {
    isValid: KnockoutObservable<boolean>
    getPermissions: () => IOrganization[]
    mutableOrganizations: KnockoutObservableArray<Organization>
}
